import InteractiveService from "services/InteractiveService";
import { stage } from "../keyPaths";
import { updateScreenPostConfigChanges } from "./components";
import ComponentService from "services/ComponentService";
import { merge } from "lodash";
import { createEmptyDataObj, updateConfigByKeypath, restoreAnnotationsAttached, deleteAnnotationsAttached, syncAssets } from "../utils";
import { CommandAuthorManualGradingConfigurationDelete, CommandAuthorManualGradingConfigurationSet } from "containers/ConnectionManager/ManualGrading/actions";
import { dispatch } from "pluginServices/store";
import { EVENT_NAMES, ACTIONS } from "services/UndoRedoService/constants/undoRedo";

const revertAnnotations = async (annotations, eventType) => {
  if (eventType === ACTIONS.UNDO) {
    await restoreAnnotationsAttached(annotations);
  } else if (eventType === ACTIONS.REDO) {
    await deleteAnnotationsAttached(annotations);
  }
};

export const revertConfig = async ({ annotations, ...action }, eventType, previousConfig) => {
  // Get current config before reverting to compare assets
  const currentElement = await InteractiveService.getInteractive(previousConfig.elementId);
  const currentStageConfig = currentElement?.config?.stage;

  await updateConfigByKeypath(previousConfig.elementId, action, eventType);
  await InteractiveService.saveInInteractiveConfig(previousConfig.elementId, stage, previousConfig.config);

  // Sync assets: add restored assets, remove deleted assets
  await syncAssets(previousConfig.elementId, currentStageConfig, previousConfig.config);

  if (annotations?.annotationIds.length) {
    await revertAnnotations(annotations, eventType);
  }
  updateScreenPostConfigChanges(action, eventType);
};

export const revertComponentConfig = async (action, eventType, previousConfig) => {
  const updatedConfig = merge(createEmptyDataObj(action.data || {}), previousConfig.config);
  await ComponentService.saveInComponentConfig(previousConfig.elementId, [], updatedConfig, EVENT_NAMES.UNDO_REDO);
};

export const revertManualGradingConfig = async (action, eventType, previousConfig) => {
  const previousGrading = previousConfig.config.previousGrading 
    ? previousConfig.config.__grading 
    : action.data.previousGrading;

  if (previousGrading.isEnabled) {
    dispatch(CommandAuthorManualGradingConfigurationSet(previousConfig.elementId, previousGrading));
  } else {
    dispatch(CommandAuthorManualGradingConfigurationDelete(previousConfig.elementId));
  }
};